<!-- Sequence summary -->
<div class="hss-row seq-summary">
  <span [class.e-label]="enhanced"
    >SEQ {{ hssBuilderService.getSequenceStatus(hss) }}</span
  >
  <span
    [class.e-seq-sum]="enhanced"
    [class]="
      hssBuilderService.getChangedClass(
        hss.summary.greaterTime.didChange,
        index
      )
    "
    >{{ hss.summary.greaterTime.text.padStart(6, " ") }}</span
  >
  <span [class.e-label]="enhanced">{{ "P/C".padStart(11, " ") }}</span>
  <span
    [class.e-seq-sum]="enhanced"
    [class]="
      hssBuilderService.getChangedClass(
        hss.summary.payCreditDisplayed.didChange,
        index
      )
    "
    >{{ hss.summary.payCreditDisplayed.text.padStart(6, " ") }}</span
  >
  <span [class.e-label]="enhanced">{{ "TL".padStart(4, " ") }}</span>
  <span
    [class.e-seq-sum]="enhanced"
    [class]="
      hssBuilderService.getChangedClass(hss.summary.totalPay.didChange, index)
    "
    >{{ hss.summary.totalPay.text.padStart(6, " ") }}</span
  >
  @if (hssBuilderService.getTafb(hss); as tafb) {
    <span [class.e-label]="enhanced"> TAFB </span>
    <span
      [class.e-seq-sum]="enhanced"
      [class]="hssBuilderService.getChangedClass(tafb.didChange, index)"
      >{{ tafb.text.padStart(6, " ") }}</span
    >
  }
</div>
